import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from "@core/scripts/helper/url";
import {useQuery} from "@tanstack/react-query";
import useMobileNavigation from "./use-mobile-navigation.js";
import {NAVIGATION_STALE_TIME} from "../navigation/constants.js";

const fetchActiveNavigationItems = async (currentShopId, currentPage) => {
    const absoluteUrl = URL.toAbsolute('/ajax/navigation/mobile/active/');
    const currentShopIdPath = currentShopId ? `&shopId=${currentShopId}` : '';
    const requestUrl = `${absoluteUrl}?currentPage=${currentPage}${currentShopIdPath}`;


    const response = await fetchWithCSRF(requestUrl, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch navigation items');
    }

    return response.json();
};

const applyActiveStates =async (mobileNavigation, currentShopId, currentPage) => {
    const activeIds = await fetchActiveNavigationItems(currentShopId, currentPage)

    const navigationItems = mobileNavigation.navigationItems;
    const texts = mobileNavigation.texts;

    return {activeIds,navigationItems, texts };
}

const useNavigationItemsWithActive = (currentShopId, currentPage) => {
    const {data: mobileNavigation} = useMobileNavigation();
    return useQuery({
        queryKey: ['navigation/mobile/active', currentShopId, currentPage],
        queryFn: () => applyActiveStates(mobileNavigation, currentShopId, currentPage),
        enabled: !!mobileNavigation,
        staleTime: NAVIGATION_STALE_TIME,
    });
};
export default useNavigationItemsWithActive;